<template>
    <rkm-modal
        body-class="p-0"
        extra-large
        ref="RkmModal"
        title="Solicitação de exame laboratorial"
    >
        <rkm-row>
            <rkm-col class="ml-2 pr-4">
                <rkm-row>
                    <rkm-col
                        v-if="hasKitsExames"
                        class="rkm-col px-3"
                        cols="4"
                    >
                        <rkm-area
                            title="Kit de Exames"
                            type="section"
                        >
                            <rkm-form-checkbox
                                v-for="(kit, i) in data.form.solicitacaoExameComum.kitsExames"
                                v-bind:key="`rkm-form-checkbox-kit-${i}`"
                                :checked="kit.exames.every(exame => model.exames.find(e => e.id === exame.id))"
                                :class="'rkm-form-checkbox' + (i === data.form.solicitacaoExameComum.kitsExames.length - 1 ? '' : ' mb-1')"
                                :id="'popover-' + i"
                                :indeterminate="kit.exames.every(exame => model.exames.find(e => e.id === exame.id)) === false ? kit.exames.some(exame => model.exames.find(e => e.id === exame.id)) : false"
                                @change="handleKitExameChange($event, kit)"
                            >
                                {{kit.nome}}
                            </rkm-form-checkbox>

                            <rkm-popover
                                v-for="(kit, i) in data.form.solicitacaoExameComum.kitsExames"
                                v-bind:key="i"
                                :target="'popover-' + i"
                                class="rkm-popover"
                                triggers="hover"
                            >
                                <div>
                                    <rkm-form-checkbox
                                        v-for="(exame, j) in kit.exames"
                                        v-bind:key="`rkm-form-checkbox-exame-${j}`"
                                        :class="'rkm-form-checkbox' + (j === kit.exames.length - 1 ? '' : ' mb-1')"
                                        :checked="!!model.exames.find(e => e.id === exame.id)"
                                        @change.native="handleExameKitChange($event, exame)"
                                    >
                                        {{exame.nome}}
                                    </rkm-form-checkbox>
                                </div>
                            </rkm-popover>
                        </rkm-area>
                    </rkm-col>

                    <rkm-col
                        :cols="hasKitsExames ? 8 : 12"
                        class="pt-2"
                    >
                        <rkm-form
                            ref="RkmFormExame"
                            show-legend
                        >
                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-input-autocomplete
                                        :repository="repositories.exame"
                                        :request-query-string-params="requestQueryStringParams"
                                        :search-fields="fields.autocomplete.exame"
                                        :text-field="(item) => item.codigo ? `${formatProcedimento(item.codigo)} - ${item.nome}` : item.nome"
                                        :validations="validations.exame"
                                        label="Exame"
                                        v-model="model.exame"
                                    />
                                </rkm-col>

                                <rkm-col cols="auto">
                                    <rkm-button
                                        :label="false"
                                        @click="include"
                                        color="primary"
                                    >
                                        Incluir
                                    </rkm-button>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-table
                                        :fields="fields.table"
                                        :items="model.exames"
                                        hide-filters
                                        hide-pagination
                                    >
                                        <template v-slot:cell(exame)="{ item }">
                                            {{ item.codigo ? `${formatProcedimento(item.codigo)} - ${item.nome}` : item.nome }}
                                        </template>

                                        <template v-slot:cell(actions)="{index}">
                                            <rkm-button
                                                @click="destroy(index)"
                                                color="danger"
                                                small
                                                title="Excluir"
                                            >
                                                <rkm-icon icon="trash" />
                                            </rkm-button>
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>
                        </rkm-form>

                        <rkm-form ref="RkmForm">
                            <rkm-row class="mt-2">
                                <rkm-col>
                                    <rkm-form-input-autocomplete
                                        :repository="repositories.geral.ciap"
                                        :request-query-string-params="{
                                            sexo_id: data.additionals.paciente.sexoId,
                                            show_all: true,
                                        }"
                                        :search-fields="fields.autocomplete.ciap"
                                        :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                                        @select="handleCiapSelect"
                                        label="CIAP 2"
                                        v-model="model.ciap"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>

                                <rkm-col cols="12" v-if="!model.sugestao">
                                    <rkm-form-input-autocomplete
                                        :repository="repositories.cid"
                                        :request-query-string-params="{
                                            ciap_id: model.ciap ? model.ciap.id : null,
                                            sexo: data.additionals.paciente.sexoIdentificador,
                                        }"
                                        :results-limit= "20"
                                        :search-fields="fields.autocomplete.cid"
                                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                                        label="CID 10"
                                        v-model="model.cid"
                                    >

                                        <rkm-input-group-append slot="append">
                                            <rkm-input-group-text>
                                                <rkm-form-radio-group
                                                    v-model="model.sugestao"
                                                    :disabled="data.cidSugestao.length === 0"
                                                >
                                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                                </rkm-form-radio-group>
                                            </rkm-input-group-text>
                                        </rkm-input-group-append>
                                    </rkm-form-input-autocomplete>
                                </rkm-col>

                                <rkm-col cols="12" v-else>
                                    <rkm-form-select
                                        :options="data.cidSugestao"
                                        label="CID 10"
                                        show-default-option
                                        text-field="codigoNome"
                                        v-model="model.cidId"
                                        value-field="id"
                                    >

                                        <rkm-input-group-append slot="append">
                                            <rkm-input-group-text>
                                                <rkm-form-radio-group v-model="model.sugestao">
                                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                                </rkm-form-radio-group>
                                            </rkm-input-group-text>
                                        </rkm-input-group-append>
                                    </rkm-form-select>
                                </rkm-col>
                            </rkm-row>

                            <BoxClassificacaoRisco :data="classificacaoRiscoData" :encaminhamento="true" />

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-textarea
                                        :validations="validations.justificativa"
                                        label="Justificativa do procedimento"
                                        maxlength="5000"
                                        rows="4"
                                        v-model="model.justificativa"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-textarea
                                        :validations="validations.observacao"
                                        label="Observações"
                                        rows="4"
                                        maxlength="500"
                                        v-model="model.observacao"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form>
                    </rkm-col>
                </rkm-row>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxClassificacaoRisco from '@/components/ambulatorio/components/classificacao-risco/Index'

// Enums.
import tipoExame from '@/enums/parametrizacao/tipoExame'
import classificacao from '@/enums/ambulatorio/solicitacaoExameClassificacao'

// Mixins.
import {error, formats, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {BoxClassificacaoRisco},
    computed: {
        hasKitsExames() {
            return this.data.form.solicitacaoExameComum.kitsExames.length > 0
        },
        requestQueryStringParams() {
            return {
                filtrar_ativos: true,
                exige_procedimento: true,
                paciente_id: this.data.additionals.paciente.id,
                tipo_id: this.enums.tipoExame.EXAME_LABORATORIAL,
                parametrizacao_exame_laboratorial_infraestrutura_id: this.data.additionals.infraestruturaId,
            }
        },
        validations() {
            return {
                exame: {required: true},
                justificativa: {
                    required: true,
                    max: 5000,
                },
                observacao: {max: 500},
            }
        },
        classificacaoRiscoData() {
            return {
                form: this.data.form.solicitacaoExameComum,
                model: this.model
            }
        }
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {tipoExame, classificacao},
        fields: {
            autocomplete: {
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
                ciap: [
                    {key: 'geral_ciap.codigo', searchable: true},
                    {key: 'geral_ciap.descricao', searchable: true},
                ],
                exame: [
                    {key: 'parametrizacao_exame.codigo', searchable: true},
                    {key: 'parametrizacao_exame.nome', searchable: true},
                    {key: 'parametrizacao_procedimento.apelido', searchable: true},
                ]
            },
            table: [
                {key: 'exame', label: 'Exame', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        item: null,
        model: {
            exame: null,
            cid: null,
            cidId: null,
            ciap: null,
            classificacaoRiscoId: null,
            justificativa: null,
            observacao: null,
            exames: [],
            sugestao: false,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 && this.item.cid ? this.item.cid.id : null,
                ciap: this.item.ciap,
                classificacaoRiscoId: this.item.classificacaoRiscoId,
                justificativa: this.item.justificativa,
                observacao: this.item.observacao,
                exames: this.item.exames,
                sugestao: false,
            })
        },
        include() {
            this.$refs.RkmFormExame.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.exames.find(exame => exame.id === this.model.exame.id)) {
                        this.showValidationNotification('O exame já foi incluído.')
                        return
                    }

                    let examePreDefinido = this.data.model.exameSolicitado.find(e => e.codigoProcedimento === this.model.exame.codigo)

                    if (examePreDefinido) {
                        this.showValidationNotification(`O exame já foi solicitado ao marcar a checkbox "${examePreDefinido.descricao}" na box "Exames".`)
                        return
                    }

                    examePreDefinido = this.data.model.triagemNeonatal.find(e => e.codigoProcedimento === this.model.exame.codigo)

                    if (examePreDefinido) {
                        this.showValidationNotification(`O exame já foi solicitado ao marcar a checkbox "${examePreDefinido.descricao}" na box "Triagem neonatal".`)
                        return
                    }

                    if ((this.data.form.exameSolicitadoAvaliado.find(es => es.codigoProcedimento === this.model.exame.codigo)
                        || this.data.form.triagemNeonatal.find(tn => tn.codigoProcedimento === this.model.exame.codigo))
                        && this.data.model.solicitacoesExamesComuns.find(se => !!se.exames.find(e => e.codigo === this.model.exame.codigo))
                    ) {
                        this.showValidationNotification(`O exame já foi incluído em outra solicitação de exames.`)
                        return
                    }

                    const request = {
                        pacienteId: this.data.additionals.paciente.id,
                        exameId: this.model.exame.id,
                    }

                    this.setLoading()

                    this.repositories.atendimento.exameDentroPrazoValidade(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            const include = () => {
                                this.model.exames.push({
                                    id: this.model.exame.id,
                                    codigo: this.model.exame.codigo,
                                    nome: this.model.exame.nome,
                                    tipoId: this.model.exame.tipoId,
                                })

                                this.resetFormExame()
                            }

                            if (response.data) {

                                if (this.data.additionals.permiteExameLaboratorialRepetido) {

                                    this.showWarningConfirmation(
                                        'Atenção',
                                        'O exame está dentro do prazo de validade. Deseja continuar?',
                                        async () => include()
                                    )
                                } else {

                                    this.showAlert('O exame já está solicitado ao paciente e dentro do prazo de validade.', "Atenção");
                                }
                            } else {
                                include()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o exame?', async () => {
                this.model.exames.splice(index, 1)
            })
        },
        resetFormExame() {
            this.model.exame = null
            this.$nextTick().then(() => this.$refs.RkmFormExame.resetValidator())
        },
        store() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            this.data.model.solicitacoesExamesComuns.push({
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoExameComum.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                exames: this.model.exames.map(exame => {

                    exame.checked = true

                    return exame
                }),
            })
        },
        update() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            Object.assign(this.item, {
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoExameComum.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                exames: this.model.exames,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.exames.length === 0) {
                        this.showValidationNotification('É necessário incluir ao menos um exame para realizar a solicitação.')
                    } else {
                        if (this.item) {
                            this.update()
                        } else {
                            this.store()
                        }

                        this.$refs.RkmModal.hide()
                    }
                })
        },
        resetForm() {
            this.model.exame = null
            this.model.cid = null
            this.model.cidId = null
            this.model.ciap = null
            this.model.classificacaoRiscoId = null
            this.model.justificativa = null
            this.model.observacao = null
            this.model.exames = []
            this.model.sugestao = false
        },
        async handleKitExameChange(value, kit) {

            if (value === true) {

                const examesFiltrados = kit.exames.filter(exame =>
                    !this.data.model.exameSolicitado.find(es => es.codigoProcedimento === exame.codigo)
                    && !this.data.model.triagemNeonatal.find(e => e.codigoProcedimento === exame.codigo)
                    && !(
                        (this.data.form.exameSolicitadoAvaliado.find(es => es.codigoProcedimento === exame.codigo)
                        || this.data.form.triagemNeonatal.find(tn => tn.codigoProcedimento === exame.codigo))
                        && this.data.model.solicitacoesExamesComuns.find(se => !!se.exames.find(e => e.codigo === exame.codigo))
                    )
                );

                for (const exame of examesFiltrados) {
                    if (!this.model.exames.find(e => e.id === exame.id)) {

                        const request = {
                            pacienteId: this.data.additionals.paciente.id,
                            exameId: exame.id,
                        }

                        try {
                            this.setLoading()

                            const response = await this.repositories.atendimento.exameDentroPrazoValidade(
                                this.camelObjectKeysToSnakeRecursive(request)
                            )

                            const include = () => {
                                this.model.exames.push({
                                    id: exame.id,
                                    codigo: exame.codigo,
                                    nome: exame.nome,
                                    tipoId: exame.tipoId,
                                })
                            }

                            if (response.data) {
                                if (this.data.additionals.permiteExameLaboratorialRepetido) {
                                    this.unsetLoading()
                                    const confirmed = await new Promise(resolve => {
                                        this.showWarningConfirmation(
                                            'Atenção',
                                            `O exame <strong>${exame.codigo} - ${exame.nome}</strong> está dentro do prazo de validade. Deseja continuar?`,
                                            () => resolve(true) || Promise.resolve(),
                                            () => resolve(false) || Promise.resolve(),
                                            () => resolve(false) || Promise.resolve()
                                        )
                                    })

                                    this.setLoading()

                                    if (confirmed) include()

                                } else {

                                    this.unsetLoading()

                                    await new Promise(resolve => {
                                        this.showAlert(
                                            `O exame <strong>${exame.codigo} - ${exame.nome}</strong> já está solicitado ao paciente e dentro do prazo de validade.`,
                                            'Atenção',
                                            false,
                                            () => resolve(false)
                                        )
                                    })
                                    this.setLoading()
                                    continue
                                }
                            } else {
                                include()
                            }
                        } catch (error) {
                            this.handleError(error)
                        } finally {
                            this.unsetLoading()
                        }
                    }
                }
            } else {
                kit.exames.forEach(exame => {
                    const index = this.model.exames.findIndex(e => e.id === exame.id)
                    if (index !== -1) this.model.exames.splice(index, 1)
                })
            }
        },
        async handleExameKitChange(event, exame) {
            if (event.target.checked) {
                let examePreDefinido = this.data.model.exameSolicitado.find(e => e.codigoProcedimento === exame.codigo)

                if (examePreDefinido) {
                    this.showValidationNotification(`O exame já foi solicitado ao marcar a checkbox "${examePreDefinido.descricao}" na box "Exames".`)

                    event.target.checked = false

                    return
                }

                examePreDefinido = this.data.model.triagemNeonatal.find(e => e.codigoProcedimento === exame.codigo)

                if (examePreDefinido) {
                    this.showValidationNotification(`O exame já foi solicitado ao marcar a checkbox "${examePreDefinido.descricao}" na box "Triagem neonatal".`)

                    event.target.checked = false

                    return
                }

                if ((this.data.form.exameSolicitadoAvaliado.find(es => es.codigoProcedimento === exame.codigo)
                    || this.data.form.triagemNeonatal.find(tn => tn.codigoProcedimento === exame.codigo))
                    && this.data.model.solicitacoesExamesComuns.find(se => !!se.exames.find(e => e.codigo === exame.codigo))
                ) {
                    this.showValidationNotification(`O exame já foi incluído em outra solicitação de exames.`)

                    event.target.checked = false

                    return
                }

                const request = {
                    pacienteId: this.data.additionals.paciente.id,
                    exameId: exame.id,
                }

                try {
                    this.setLoading()

                    const response = await this.repositories.atendimento.exameDentroPrazoValidade(
                        this.camelObjectKeysToSnakeRecursive(request)
                    )

                    const include = () => {
                        this.model.exames.push({
                            id: exame.id,
                            codigo: exame.codigo,
                            nome: exame.nome,
                            tipoId: exame.tipoId,
                        })
                    }

                    if (response.data) {
                        if (this.data.additionals.permiteExameLaboratorialRepetido) {
                            this.unsetLoading()

                            const confirmed = await new Promise(resolve => {
                                this.showWarningConfirmation(
                                    'Atenção',
                                    `O exame <strong>${exame.codigo} - ${exame.nome}</strong> está dentro do prazo de validade. Deseja continuar?`,
                                    () => resolve(true) || Promise.resolve(),
                                    () => resolve(false) || Promise.resolve(),
                                    () => resolve(false) || Promise.resolve()
                                )
                            })

                            this.setLoading()

                            if (confirmed) include()
                        } else {
                            this.unsetLoading()

                            await new Promise(resolve => {
                                this.showAlert(
                                    `O exame <strong>${exame.codigo} - ${exame.nome}</strong> já está solicitado ao paciente e dentro do prazo de validade.`,
                                    'Atenção',
                                    false,
                                    () => resolve(false) || Promise.resolve()
                                )
                            })

                            this.setLoading()
                        }
                    } else {
                        include()
                    }
                } catch (error) {
                    this.handleError(error)
                } finally {
                    this.unsetLoading()
                }
            } else {
                this.model.exames.splice(this.model.exames.findIndex(exame => exame.id === parseInt(exame.id)) , 1)
            }
        },
        handleCiapSelect(value) {
            if (value.cidId) {
                this.model.cid = {
                    id: value.cidId,
                    codigo: value.cidCodigo,
                    nome: value.cidNome,
                }
                this.model.sugestao = false
            }
        },
    },
    mixins: [error, formats, object, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>

<style scoped>
.rkm-popover {
    min-width: 300px;
}
.rkm-col {
    background-color: #f8f9fa;
}
.rkm-form-checkbox {
    display: flex;
    margin: 0;
    padding: 0;
}
.rkm-form-checkbox >>> .custom-control-label {
    align-self: center;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.05);
    flex-grow: 1;
    padding-bottom: 0.5rem;
    padding-left: 2rem;
    padding-right: 0.5rem;
    padding-top: 0.5rem;
}
.rkm-form-checkbox >>> .custom-control-label:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
.rkm-form-checkbox >>> .custom-control-label:before {
    left: 0.7rem;
    position: absolute;
    top: 0.7rem;
}
.rkm-form-checkbox >>> .custom-control-label::after {
    left: 0.7rem;
    position: absolute;
    top: 0.7rem;
}
</style>